import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { BrandMark } from '../../components/BrandMark';
import { Eyebrow } from '../../components/Eyebrow';
import { Headline } from '../../components/Headline';
import { LegalLinks } from '../../components/LegalLinks';
import styles from './legal.module.css';

export const EFFECTIVE_DATE = '4 November 2026';
export const CONTACT_EMAIL = 'hello@painpal.cc';

// A paragraph, or a bulleted list.
export type LegalBlock = ReactNode | readonly ReactNode[];
export interface LegalSection { title: string; blocks: readonly LegalBlock[] }

export const ContactLink = () => <a className={styles.inline} href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>;

function Block({ block }: { block: LegalBlock }) {
  if (!Array.isArray(block)) return <p className={styles.para}>{block}</p>;
  return <ul className={styles.list}>{block.map((item, i) => <li key={i}>{item}</li>)}</ul>;
}

export function LegalPage({ title, sections }: { title: string; sections: readonly LegalSection[] }) {
  return (
    <div className={styles.page}>
      <header className={styles.top}>
        <Link to="/" aria-label="PainPal home"><BrandMark /></Link>
      </header>
      <main className={styles.body}>
        <header className="page-heading">
          <Eyebrow>{`EFFECTIVE ${EFFECTIVE_DATE.toUpperCase()}`}</Eyebrow>
          <Headline first="PAINPAL" second={`${title}.`} size="compact" />
        </header>
        {sections.map((s, i) => (
          <section key={s.title} className={styles.section} aria-labelledby={`legal-${i}`}>
            <h2 id={`legal-${i}`} className={styles.heading}>{`${String(i + 1).padStart(2, '0')} · ${s.title}`}</h2>
            {s.blocks.map((block, j) => <Block key={j} block={block} />)}
          </section>
        ))}
        <footer className={styles.footer}><LegalLinks /></footer>
      </main>
    </div>
  );
}
